import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (data) =>
    present(
      repository
        .saveAccount(data)
        .then(() => data)
        .catch((error) => Promise.reject({ error, data })),
    );
}

export type { Interactor };

export { createInteractor };
